import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".cls-1{fill:#fff}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", { id: "Ebene_1" }, [
      _createElementVNode("path", {
        d: "M8 10h2v16H8zm4 0h2v16h-2zm4 0h2v16h-2zM0 4h26v2H0zm18 0h-2V3c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v1H8V3c0-1.7 1.3-3 3-3h4c1.7 0 3 1.3 3 3z",
        class: "cls-1"
      }),
      _createElementVNode("path", {
        d: "M19 32H7c-1.6 0-3-1.3-3.2-2.9L2 5.1l2-.2 1.8 24c0 .6.6 1.1 1.2 1.1h12c.6 0 1.1-.5 1.2-1.1l1.8-24 2 .2-1.8 24C22 30.7 20.6 32 19 32",
        class: "cls-1"
      })
    ], -1))
  ]))
}
export default { render: render }